<div class="container mt-2">
  <!-- Driver Details Section -->
  <div class="card mb-4 shadow-sm">
    <div class="card-body">
      <h5 class="card-title text-primary">User Details</h5>
      <hr />
      <div class="row">
        <div class="col-md-4 mb-3">
          <h6 class="mb-1">User Name:</h6>
          <p class="text-muted mb-0">
            {{ userData.firstName }} {{ userData.lastName }}
          </p>
        </div>
        <div class="col-md-4 mb-3">
          <h6 class="mb-1">Mobile Number:</h6>
          <p class="text-muted mb-0">+91 {{ userData.phoneNumber }}</p>
        </div>
        <!-- <div class="col-md-4">
          <h6 class="mb-1">Vehicle Type:</h6>
          <p class="text-muted mb-0">{{vehicleType}}</p>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Current Balance Section -->
  <div class="card mb-3 shadow border-0 shadow-sm">
    <div class="card-body justify-content-start align-items-center">
      <h6 class="card-title mb-0">Current Balance</h6>
      <h1 class="display-6 text-success mb-0">{{ walletBalance }}</h1>
    </div>
  </div>

  <!-- Transaction History Table -->
  <div class="card shadow-sm">
    <div
      class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
    >
      <h5 class="mb-0">Transaction History</h5>
      <div>
        <!-- Export to Excel Button -->
        <button
          class="btn btn-light btn-sm me-2"
          (click)="exportTableToExcel('transactionTable', 'TransactionHistory')"
        >
          Export Current Page
        </button>
        <!-- Export All to Excel Button -->
        <button class="btn btn-light btn-sm" (click)="getAllTransactionData()">
          Export All to Excel
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table
          class="table table-bordered table-hover mb-0"
          id="transactionTable"
        >
          <thead class="table-light">
            <tr>
              <!-- <th>#</th> -->
              <th>Date</th>
              <th>Package ID</th>
              <th>Amount</th>
              <th>Transaction Type</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr class="fw-bold" *ngFor="let data of transactionData">
              <td>
                {{
                  data.createdOnTS * 1000
                    | date : "dd MMM yyyy hh:mm a" : "en-IN"
                }}
              </td>
              <td>{{ data.packageId }}</td>
              <td
                class=""
                [ngClass]="{
                  ' text-success': data.type === 'CREDIT',
                  ' text-danger': data.type === 'DEBIT',
                  ' bg-warning': data.type === ''
                }"
              >
                {{
                  data.type === "CREDIT"
                    ? "+"
                    : data.type === "DEBIT"
                    ? "-"
                    : ""
                }}{{ data.amount }}
              </td>
              <td>
                <span
                  class="badge rounded-pill"
                  [ngClass]="{
                    ' bg-success': data.type === 'CREDIT',
                    ' bg-danger': data.type === 'DEBIT',
                    ' bg-warning': data.type === ''
                  }"
                  >{{ data.type }}</span
                >
              </td>
              <td>{{ data.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ngb-pagination
        (pageChange)="gty((page = $event))"
        [collectionSize]="totalItems"
        [(page)]="page"
        [pageSize]="itemsPerPage"
        [maxSize]="3"
        [rotate]="true"
        [boundaryLinks]="false"
      >
      </ngb-pagination>
    </div>
  </div>
</div>
